<template>
    <div v-show="pageShow">
        <Header/>
        <div class="container mt-5">
            <h6>ตารางสถานะ</h6>
            <table class="table table-hover table-striped">
                <thead>
                    <tr class="thead-light text-center">
                        <th>ลำดับ</th>
                        <th>รหัสสั่งซื้อ</th>
                        <th>จำนวนรายการ</th>
                        <th>ยอดเงิน</th>
                        <th>สถานะชำระเงิน</th>
                        <th>สถานะจัดส่ง</th>
                        <th>วันที่สั่งซื้อ</th>
                    </tr>
                </thead>
                <tbody v-if="workStatus!=''">
                    <tr v-for="(status,index) in workStatus" :key="status.index" class="table-hover text-center"> 
                        <td class="text-gray">{{++index}}</td>
                        <td class="text-gray">{{status.order_id}}</td>
                        <td class="text-gray">{{status.list_product}}</td>
                        <td class="text-right text-dark">{{status.total_price | numberFormat}} THB</td>
                        <td>
                            <span v-if="status.payment_status==='กำลังดำเนินการ'" class="text-warning">{{status.payment_status}}</span>
                            <span v-else-if="status.payment_status==='ชำระเรียบร้อย'" class="text-success">{{status.payment_status}}</span>
                            <span v-else class="text-danger">{{status.payment_status}}</span>
                        </td>
                        <td class="text-gray">
                            <span v-if="status.delivery_status==='กำลังดำเนินการ'" class="text-warning">{{status.delivery_status}}</span>
                            <span v-else class="text-success">{{status.payment_status}}</span>
                        </td>
                        <td class="text-gray">{{status.created_at}}</td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="7" class="text-center text-gray">ไม่มีข้อมูล</td>
                    </tr>
                </tbody>
            </table>
            <h6>แจ้งสั่งซื้อ</h6><hr>
            <div class="row">
                <div class="col-lg-6 col-sm-12 d-flex justify-content-center">
                    <div>
                        <p class="text-gray text-10">
                            <span class="text-bold">เงื่อนไขการแจ้งโอนเงิน</span><br>
                            1.ลุูกค้าต้องโอนยอดเงินตามใบสั่งซื้อสินค้า<br>
                            2.ลูกค้าทำการโอนเงินเรียบร้อย ลูกค้าต้องทำการแนบสลิปโอนเงิน<br>
                            3.ถ้าหากลูกค้าโอนเงินไม่ครบตามจำนวนยอดเงินใบสั่งซื้อ ทางเราจะไม่จัดส่งสินค้าจนกว่าลูกค้าจะโอนเงินครบจำนวน<br>
                            4.ถ้าลูกค้าทำการปลอมแปลงสลิปโอนเงิน ทางเราขอสงวนสิทธิ์ยกเลิกการสั่งซื้อสินค้าตามใบเลขที่สั่งซื้อ
                        </p>
                        <form @submit.prevent="payment()">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <label class="input-group-text" for="order_id">รหัสสั่งซื้อ</label>
                                </div>
                                <select class="custom-select" id="order_id" v-model="order_id" v-validate="'required'" name="order_id" :class="{'input': true, 'is-invalid': errors.has('order_id') }">
                                    <option disabled v-if="listNotPays==''">ไม่มีรายการสั่งซื้อ</option>
                                    <option v-for="list in listNotPays" :key="list.index" :value="list.order_id">{{list.order_id}}</option>
                                </select>
                            </div>
                            <i v-show="errors.has('order_id')" class="fas fa-warning"></i>
                            <span v-show="errors.has('order_id')" class="text-danger text-10">{{ errors.first('order_id') }}</span><br>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroupFileAddon01">สลิปโอนเงิน</span>
                                </div>
                                <div class="custom-file">
                                    <input type="file" @change="getImg" v-validate="'required'" name="path_file" id="path_file" ref="path_file" class="custom-file-input" :class="{'input': true, 'is-invalid': errors.has('path_file')}" aria-describedby="inputGroupFileAddon01">
                                    <label class="custom-file-label" for="path_file">เลือกไฟล์รูปภาพ</label>
                                </div>
                            </div>
                            <i v-show="errors.has('path_file')" class="fas fa-warning"></i>
                            <span v-show="errors.has('path_file')" class="text-danger text-10">{{ errors.first('path_file') }}</span><br>
                            <div class="form-group">
                                <button type="submit" class="btn btn-sm btn-block bg-orange text-light">แจ้งสั่งซื้อ</button>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="col-lg-6 col-sm-12 d-flex justify-content-center">
                    <img src="../../dist/payment.jpg" class="img-fluid">
                </div>
            </div>
            <!-- <h6>ประวัติการซื้อสินค้า</h6><hr> -->
            <h6>วิธีแจ้งสั่งซื้อ</h6><hr>
            <div class="row">
                <div class="col-md-3 dotted p-2 mb-2" data-aos="zoom-in">
                    <div class="text-center">
                        <svg height="50" viewBox="-88 0 464 464" width="50" xmlns="http://www.w3.org/2000/svg"><path d="m16 0h256c8.800781 0 16 7.199219 16 16v128c0 8.800781-7.199219 16-16 16h-256c-8.800781 0-16-7.199219-16-16v-128c0-8.800781 7.199219-16 16-16zm0 0" fill="#2ab793"/><g fill="#fff"><path d="m172.800781 24c-7.199219 0-13.601562 4.800781-16 12.800781l-2.402343 11.199219h-40.796876c-8.800781 0-16 7.199219-16 16v3.199219l4.796876 24c1.601562 7.199219 8 12.800781 16 12.800781h27.203124c7.199219 0 13.597657-4.800781 16-12.800781l11.199219-51.199219h19.199219v-16zm-27.199219 64h-27.203124l-4.796876-24h37.597657zm0 0"/><path d="m112 112h16v16h-16zm0 0"/><path d="m144 112h16v16h-16zm0 0"/></g><path d="m232 248h-104v-80c0-8.800781-7.199219-16-16-16h-8c-8.800781 0-16 7.199219-16 16v104h-24c-8.800781 0-16 7.199219-16 16v56l48 88v32h128v-32l24-56v-112c0-8.800781-7.199219-16-16-16zm0 0" fill="#efccbf"/><path d="m198.398438 412.800781-12.796876-9.601562 14.398438-21.597657v-29.601562h16v34.398438zm0 0" fill="#c9a8a3"/><path d="m96 432h128v32h-128zm0 0" fill="#c9a8a3"/><path d="m88 312-16-40h16zm0 0" fill="#c9a8a3"/></svg>
                        <h6 class="text-blue mt-2">คลิกแจ้งชำระเงิน</h6>
                        <i class="fas fa-arrow-right fa-2x text-danger"></i>
                    </div>
                </div>
                <div class="col-md-3 dotted p-2 mb-2" data-aos="zoom-in">
                    <div class="text-center">
                        <svg height="50" viewBox="0 0 496 496" width="50" xmlns="http://www.w3.org/2000/svg"><path d="m144 0v200l4.839844 3.160156 55.839844-55.839844c7.25-7.25 17.074218-11.320312 27.320312-11.320312s20.070312 4.070312 27.3125 11.3125l89.375 89.375c7.242188 7.242188 11.3125 17.066406 11.3125 27.3125 0 10.238281-4.070312 20.070312-11.3125 27.3125l-25.527344 25.527344 4.839844 3.160156h168v-320zm0 0" fill="#f0bc5e"/><path d="m184 419.3125-107.3125-107.3125 123.3125-123.3125 107.3125 107.3125zm0 0" fill="#f0bc5e"/><path d="m264.96875 141.65625c-8.800781-8.808594-20.511719-13.65625-32.96875-13.65625s-24.167969 4.847656-32.96875 13.65625l-185.375 185.375c-8.679688 8.679688-13.65625 20.695312-13.65625 32.96875s4.976562 24.289062 13.65625 32.96875l89.375 89.375c8.800781 8.808594 20.511719 13.65625 32.96875 13.65625s24.167969-4.847656 32.96875-13.65625l185.375-185.375c8.679688-8.679688 13.65625-20.695312 13.65625-32.96875 0-12.457031-4.847656-24.167969-13.65625-32.96875zm67.71875 154.34375-148.6875 148.6875-132.6875-132.6875 148.6875-148.6875zm-175.03125 175.03125c-11.566406 11.5625-31.746094 11.5625-43.3125 0l-89.375-89.375c-5.695312-5.703125-8.96875-13.59375-8.96875-21.65625s3.273438-15.953125 8.96875-21.65625l15.03125-15.03125 132.6875 132.6875zm186.246094-186.4375-132.496094-132.496094c5.65625-5.175781 12.882812-8.097656 20.59375-8.097656 8.175781 0 15.871094 3.183594 21.65625 8.96875l89.375 89.375c5.785156 5.785156 8.96875 13.480469 8.96875 21.65625 0 7.601562-2.992188 14.984375-8.097656 20.59375zm0 0"/><path d="m58.339844 389.652344 11.3125-11.3125 47.996094 47.996094-11.3125 11.316406zm0 0"/><path d="m237.65625 320.398438 24.398438-24.398438-24.398438-24.398438-11.3125 11.308594 13.089844 13.089844-13.089844 13.089844zm0 0"/><path d="m200 256.566406 13.089844 13.089844 11.308594-11.3125-24.398438-24.398438-24.398438 24.398438 11.308594 11.3125zm0 0"/><path d="m146.34375 336.398438 11.3125-11.308594-13.089844-13.089844 13.089844-13.089844-11.3125-11.308594-24.398438 24.398438zm0 0"/><path d="m208.398438 349.65625-11.308594-11.3125-13.089844 13.089844-13.089844-13.089844-11.308594 11.3125 24.398438 24.398438zm0 0"/><path d="m192 328c13.230469 0 24-10.769531 24-24s-10.769531-24-24-24-24 10.769531-24 24 10.769531 24 24 24zm0-32c4.40625 0 8 3.585938 8 8s-3.59375 8-8 8-8-3.585938-8-8 3.59375-8 8-8zm0 0"/><path d="m256 .664062h-16v95.335938h-95.871094v16h111.871094zm0 0"/><path d="m224 32h-48v48h48zm-16 32h-16v-16h16zm0 0"/><path d="m400 96v-95.871094h-16v111.871094h111.753906v-16zm0 0"/><path d="m464 32h-48v48h48zm-16 32h-16v-16h16zm0 0"/><path d="m336 72h-48v-40h-16v56h64zm0 0"/><path d="m352 112h16v-88h-64v16h48zm0 0"/><path d="m416 160h16v-16h32v-16h-48zm0 0"/><path d="m448 176h-32v16h48v-32h-16zm0 0"/><path d="m272 104h16v16h-16zm0 0"/><path d="m304 104h16v16h-16zm0 0"/><path d="m176 128h16v16h-16zm0 0"/><path d="m416 256h32v32h16v-48h-48zm0 0"/><path d="m400 240h-16v48h48v-16h-32zm0 0"/><path d="m448 208h16v16h-16zm0 0"/><path d="m416 208h16v16h-16zm0 0"/><path d="m384 208h16v16h-16zm0 0"/><path d="m400 128h-48v16h32v48h16zm0 0"/><path d="m336 136h-16v40h48v-16h-32zm0 0"/></svg>
                        <h6 class="text-blue mt-2">สแกนเพื่อชำระเงินหรือโอนเงิน</h6>
                        <i class="fas fa-arrow-right fa-2x text-danger"></i>
                    </div>
                </div>
                <div class="col-md-3 dotted p-2 mb-2" data-aos="zoom-in">
                    <div class="text-center">
                        <svg height="50" viewBox="0 -24 480 480" width="50" xmlns="http://www.w3.org/2000/svg"><path d="m152 48v-40h-112v104h432v-64zm0 0" fill="#79bd9a"/><path d="m40 80h400v32h-400zm0 0" fill="#a8dba8"/><path d="m472 112h-464v312h464v-64h-232c-88.367188 0-160-71.632812-160-160v-88zm0 0" fill="#cff09e"/><path d="m344 272c0 57.4375-46.5625 104-104 104s-104-46.5625-104-104 46.5625-104 104-104 104 46.5625 104 104zm0 0" fill="#79bd9a"/><path d="m272 264v64h-64v-64h-32l64-64 64 64zm0 0" fill="#a8dba8"/><g fill="#3b8686"><path d="m472 40h-312v-32c0-4.417969-3.582031-8-8-8h-112c-4.417969 0-8 3.582031-8 8v96h-24c-4.417969 0-8 3.582031-8 8v312c0 4.417969 3.582031 8 8 8h464c4.417969 0 8-3.582031 8-8v-376c0-4.417969-3.582031-8-8-8zm-328-24v32c0 4.417969 3.582031 8 8 8h312v48h-16v-24c0-4.417969-3.582031-8-8-8h-392v-56zm-96 72h384v16h-384zm416 328h-448v-296h448zm0 0"/><path d="m240 192c-2.117188.03125-4.148438.859375-5.679688 2.320312l-64 64c-2.269531 2.300782-2.933593 5.742188-1.679687 8.71875 1.226563 2.988282 4.128906 4.945313 7.359375 4.960938h24v56c0 4.417969 3.582031 8 8 8h64c4.417969 0 8-3.582031 8-8v-56h24c3.230469-.015625 6.132812-1.972656 7.359375-4.960938 1.253906-2.976562.589844-6.417968-1.679687-8.71875l-64-64c-1.507813-1.496093-3.554688-2.332031-5.679688-2.320312zm32 64c-4.417969 0-8 3.582031-8 8v56h-48v-56c0-4.417969-3.582031-8-8-8h-12.71875l44.71875-44.71875 44.71875 44.71875zm0 0"/><path d="m240 160c-61.855469 0-112 50.144531-112 112s50.144531 112 112 112 112-50.144531 112-112-50.144531-112-112-112zm0 208c-53.019531 0-96-42.980469-96-96s42.980469-96 96-96 96 42.980469 96 96-42.980469 96-96 96zm0 0"/></g></svg>
                        <h6 class="text-blue mt-2">อัพรูปสลิปเพื่อแจ้งชำระเงิน</h6>
                        <i class="fas fa-check-circle fa-2x text-success"></i>
                    </div>
                </div>
            </div>
        </div>
        <br><br><br><br>
        <Footer/>
    </div>
</template>

<script>
import Header from '../components/Header'
import Footer from '../components/Footer'
    export default {
        components: {
            Header,Footer,
        },
        beforeCreate(){
            this.axios.post('http://pgm01.toonjob.com/2019/BannKlong/project/checkBeforeLoginCus',{
                keyid_cus: this.$session.get('keyid_cus'),
                keyserial_cus: this.$session.get('keyserial_cus'),
                keytoken_cus: this.$session.get('keytoken_cus'),
            })
            .then((res)=>{
                let data = parseInt(res.data.checkLoginCus)
                if(data === 0){
                    this.pageShow = false
                    window.location.href = '/'
                }else{
                    this.pageShow = true
                }
            })
        },
        data(){
            return {
                pageShow: false,
                workStatus:{},
                order_id:'',
                img_slip:'',
                listNotPays:{}
            }
        },
        methods:{
            notPaymeny(){
                this.axios.post('http://pgm01.toonjob.com/2019/BannKlong/project/listNoPayment', {cus_id: this.$session.get('keyid_cus')})
                .then((res)=>{
                    this.listNotPays = res.data
                })
            },
            getImg(e){
                let file = e.target.files[0];
                if (file['type'] === 'image/jpeg' || file['type'] === 'image/png') {
                    this.img_slip = this.$refs.path_file.files[0]
                }else
                {
                    swal.fire({
                    type: "error",
                    title: "กรุณาเลือกรูปภาพใหม่",
                    text: "รองรับไฟล์นามสกุล jpeg,jpg,png เท่านั้น"
                    });
                }
            },
            payment(){
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        let dataForms = new FormData();
                        dataForms.append("cus_id", this.$session.get('keyid_cus'));
                        dataForms.append("order_id", this.order_id);
                        dataForms.append("path_file", this.img_slip);
                        const config = { headers: { "Content-Type": "multipart/form-data" } };
                        this.axios.post('http://pgm01.toonjob.com/2019/BannKlong/project/payment',dataForms,config)
                        .then((res) => {
                            toast.fire({
                                type: res.data.type,
                                title: res.data.message
                            })
                            this.order_id = ''
                            this.img_slip = ''
                            Fire.$emit('AfterPayment')
                            Fire.$emit('AfterNoPayment')
                        })
                    }
                })
            },
            myStatus(){
                this.axios.post('http://pgm01.toonjob.com/2019/BannKlong/project/workStatusCustomer', {id: this.$session.get('keyid_cus')})
                .then((res) =>{
                    this.workStatus = res.data
                })
            }
        },
        created(){
            this.$Progress.start()
            this.notPaymeny()
            Fire.$on('AfterNoPayment', () =>{
                this.notPaymeny()
            })
            this.myStatus()
            Fire.$on('AfterPayment', () =>{
                this.myStatus()
            })
            this.$Progress.finish()
        }
    }
</script>



// WEBPACK FOOTER //
// src/frontEnd/PaymentPage.vue